export function nombreDelegacion (objID: any) {

    if (objID >= 0 && objID <= 99 ) {
        return (
            "Central"
        )
    }

    else if (objID >= 100 && objID <= 199) {
        return (
            "Petén"
        )
    }

    else if (objID == null || objID == undefined ) {
        return (
            "Sin Sede"
        )
    }
    else if (objID >= 1000 && objID <= 1999) {
        return (
            "Sede Regional Norte"
        )

    }

};